export function removeAppCover() {
  const cover = document.querySelector('.cover-preloader');

  cover.addEventListener('transitionend', () => {
    cover.parentElement.removeChild(cover);
  });

  cover.classList.add('off');
}